import { REHYDRATE, FLUSH } from 'redux-persist'

import { Activity } from 'store/records/activity'
import {
  activityActions,
  subscribeToProTrack,
  unsubscribeProgress,
  getIdentityProgress,
  updateSubscribeToProTrack,
  setActivityRating,
  setCustomStory,
} from 'store/entities/identity/actions'
// @ts-ignore
import { FAVORITE_ACTIVITIES } from 'store/entities/favoriteActivities/actionTypes'
import { sendYesterdayActivity } from '../identity/actions'
import { setStory } from './actions'

export const initialState = new Activity()

const activityReducer = (state = initialState, action: any) => {
  const { type, payload } = action
  switch (type) {
    case REHYDRATE: {
      return payload && payload.activity ? payload.activity : state
    }
    case FLUSH: {
      return new Activity()
    }
    case setActivityRating.success.toString(): {
      const ratedActivityId = payload && payload.id
      if (state.get('id') === ratedActivityId) {
        return state.set('rating', payload.rate).set('isRated', true)
      }
      return state
    }
    case unsubscribeProgress.success.toString():
      return new Activity()
    case activityActions.commit.success.toString():
    case activityActions.did.success.toString():
    case activityActions.didnot.success.toString():
    case activityActions.complete.success.toString():
    case subscribeToProTrack.success.toString():
    case updateSubscribeToProTrack.success.toString():
    case getIdentityProgress.success.toString():
    case sendYesterdayActivity.success.toString(): {
      if (!payload || !payload.data || !payload.data.activity) {
        return new Activity()
      }
      const { activity } = payload.data
      return new Activity(activity)
    }
    case FAVORITE_ACTIVITIES.POST.SUCCESS: {
      if (payload.data.meta.previous === false) {
        return state.set('isFavorite', true)
      }
      return state
    }
    case FAVORITE_ACTIVITIES.DELETE.SUCCESS: {
      if (payload.data.meta.previous === false) {
        return state.set('isFavorite', false)
      }
      return state
    }
    case setStory.success.toString(): {
      return state.set('hasStory', true)
    }
    case setCustomStory.success.toString(): {
      if (payload.data.userActivityId === state.get('userActivityId')) {
        return state.set('hasStory', true)
      }

      return state
    }
    default:
      return state
  }
}

export default activityReducer
